import z from "zod";

const securityErrorTypeValues = [
  "INVALID_API_KEY_SEGMENT",
  "INVALID_API_KEY_CHECKSUM",
  "INVALID_API_KEY_FORMAT",
  "INVALID_API_KEY_VERSION",
  "UNSUPPORTED_KEY_FORMAT",
  "BROWSER_USAGE_NOT_ALLOWED",
] as const;

const securityErrorTypeSchema = z.enum(securityErrorTypeValues);
const SecurityErrorType = securityErrorTypeSchema.enum;
type SecurityErrorType = z.infer<typeof securityErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type SecurityErrors =
  | {
      errorType: typeof SecurityErrorType.INVALID_API_KEY_SEGMENT;
      data: {
        segmentName: string;
        segment?: string;
      };
    }
  | {
      errorType: typeof SecurityErrorType.INVALID_API_KEY_CHECKSUM;
      data: {
        calculatedChecksum: string;
        expectedChecksum: string;
      };
    }
  | {
      errorType: typeof SecurityErrorType.INVALID_API_KEY_FORMAT;
      data: {
        key: string;
      };
    }
  | {
      errorType: typeof SecurityErrorType.INVALID_API_KEY_VERSION;
      data: {
        version: string;
      };
    }
  | {
      errorType: typeof SecurityErrorType.UNSUPPORTED_KEY_FORMAT;
      data: {
        version: string;
        key: string;
      };
    }
  | {
      errorType: typeof SecurityErrorType.BROWSER_USAGE_NOT_ALLOWED;
      data: Record<string, never>;
    };

export const securityErrorDetails: Record<SecurityErrorType, ErrorDetails> = {
  [SecurityErrorType.INVALID_API_KEY_SEGMENT]: {
    sentryDescription: "Invalid API key segment found during parsing",
  },
  [SecurityErrorType.INVALID_API_KEY_CHECKSUM]: {
    sentryDescription: "API key checksum validation failed",
  },
  [SecurityErrorType.INVALID_API_KEY_FORMAT]: {
    sentryDescription: "API key format is invalid",
  },
  [SecurityErrorType.INVALID_API_KEY_VERSION]: {
    sentryDescription: "API key version is invalid or unsupported",
  },
  [SecurityErrorType.UNSUPPORTED_KEY_FORMAT]: {
    sentryDescription: "API key format is not supported for the given version",
  },
  [SecurityErrorType.BROWSER_USAGE_NOT_ALLOWED]: {
    sentryDescription: "Security package cannot be used in browser environment",
  },
};
